import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { loadAgentsList, resetStore  } from "../../redux/modules/agents";
import Table from "../common/table";
import Loader from "../common/loader";
import Layout from "../layout"
import Select from 'react-select';


function Agents(props) {
  const auth = useSelector(state => state.auth);
  const agents = useSelector(state => state.agents);
  const mobile = useSelector(state => state.mobile);
  const [value, setValue] = useState();
  const [selectedOption, setSelectedOption] = useState(null);
  const [items, setItems] = useState(null);
  const dispatch = useDispatch();

  
  useEffect(() => {
    document.title = 'Пользователи | Личный кабинет Брокера THE FIVE';
    
    dispatch(
      loadAgentsList({
        cmd: 'agents-list',
        _debug_token: auth.token
      }))

    return () => dispatch(resetStore())

  }, [])

  const columns = [
    { label: "Дата добавления", value: "dateAdd" },
    { label: "Имя и фамилия", value: "fio" },
    { label: "Должность", value: "position" },
    { label: "Права доступа", value: "group" },
    { label: "Телефон", value: "phone" },
    { label: "Электронная почта", value: "email" },
    { label: "Статус", value: "blacklist" },
    { label: "Действия", value: "actions" },
  ];

  const columnsmobile = [
    { label: "ФИО", value: "fio" },
    { label: "Телефон", value: "phone" },
    { label: "", value: "actions" },
    { label: "Статус", value: "blacklist" },
    { label: "Должность", value: "position" },
    { label: "Роль", value: "group" },
  ];

  const sortmobile = [
    { label: "ФИО", value: "fio" },
    { label: "Телефон", value: "phone" },
  ];

  const filter = (val, option) => {
    const filteredData = agents.response.filter(
      (el) => {
        return (
          (el.blacklist === option || option === "all") &&
          ((!value || (value && el.fio.toLowerCase().includes(val.toLowerCase()))) || (!value || (value && el.phone.includes(val))))
        )
      }
    );
    setItems(filteredData);
  };

  const changeValue = (e) => {
    setValue(e.target.value)
    filter(e.target.value, selectedOption ? selectedOption.value : 'all');
  }
  
  const selectOption = (option) => {
    setSelectedOption(option);
    filter(value, option.value);
  }

  if(agents.error) return <Layout><div className="page-error"><div className="page-error__error">{agents.error}</div></div></Layout>
  
  return (    
    <Layout>
      {agents.loading && <Loader />}
      <div className="page-agents">
        <div className="users-top">
          <form className="filter">
            <div>
              <input
                value={value}
                type={'text'}
                placeholder={'ФИО или телефон'}
                className='form__input'
                onChange={changeValue}
              />
            </div>
            <div>
              <Select
                className="select"
                classNamePrefix="select"
                placeholder={ 'Статус'}       
                isSearchable={false}
                components={{
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null,
                }} 
                defaultValue={selectedOption}
                onChange={selectOption}
                options={[
                  { value: 'all', label: 'Все статусы' },
                  { value: false, label: 'Активный' },
                  { value: true, label: 'В чёрном списке' }
                ]}
              />
            </div>
          </form>
        </div> 
        {agents.response &&  (
          <Table 
            columns={mobile ? columnsmobile : columns}
            sortmobile={sortmobile}
            data={items ? items : agents.response} 
          />
        )}
      </div>  
    </Layout>
  );
}
export default Agents;